module.exports = __webpack_public_path__ + "quicksilver/static/media/completed-background.d327b6f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Authentication/AuthCompleted/img/completed-background.svg
// module id = 467
// module chunks = 0